import type { AuthShare } from "./inertia"

type SonnyFn = ((command: "init", config: { siteId: string }) => void) &
  ((command: "identify", user: { email: string; name?: string }) => void) &
  ((command: "reset") => void)

declare global {
  interface Window {
    sonny?: SonnyFn
  }
}

let lastIdentifiedEmail: string | null = null

// Called on initial boot and after every Inertia navigation. Sonny was
// init'd in the Rails layout <head>; here we just keep the visitor's
// identity in sync as auth state changes inside the SPA. The widget loader
// queues calls made before the script finishes loading, so this is safe to
// call early.
export function syncChatIdentity(auth: AuthShare | undefined): void {
  if (typeof window === "undefined" || !window.sonny) return

  const user = auth?.user
  if (user) {
    if (lastIdentifiedEmail === user.email) return
    window.sonny("identify", { email: user.email, name: user.name })
    lastIdentifiedEmail = user.email
  } else if (lastIdentifiedEmail !== null) {
    window.sonny("reset")
    lastIdentifiedEmail = null
  }
}
